if (!customElements.get("m-sharing")) {
  customElements.define(
    "m-sharing",
    class MSharing extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          shareContent: ".m-product-addon--sharing",
          openBtn: "[data-open-share]",
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        const { shareContent } = this.domNodes;
        if (shareContent && shareContent.innerHTML) {
          this.shareContent = shareContent.innerHTML;
          this.init();
        }
      }

      init() {
        this.domNodes.openBtn && this.domNodes.openBtn.classList.remove("m:hidden");
        addEventDelegate({
          selector: this.selectors.openBtn,
          handler: (e) => {
            e.preventDefault();
            const shareContent = this.domNodes.shareContent;
            if (shareContent) {
              shareContent.classList.toggle("m:hidden");
              const input = shareContent.querySelector("input");
              if (input && !shareContent.classList.contains("m:hidden")) {
                input.select();
                navigator.clipboard.writeText(input.value).then(() => {
                  const label = shareContent.querySelector("label");
                  if (label) {
                    const original = label.textContent;
                    label.textContent = "✓ Kopyalandı!";
                    setTimeout(() => { label.textContent = original; }, 2000);
                  }
                });
              }
            }
          },
        });
      }
    }
  );
}
